module.exports = __webpack_public_path__ + "img/condition-task.cadd2076.svg";